import React, {FormEvent} from 'react';
import {Box, Button, Typography} from "@mui/material";
import {InputWithShowingResults} from "../../../../../../com/inputWithShowingResults/inputWithShowingResults";

interface Props {
    isFlyerPublished: boolean;
    readonly?: boolean;
    isValidEmailFromInputContactUsEmails: boolean;
    inputValueForContactUsEmails: string;
    contactUsEmails: string[];
    addItemToContactUsEmails: (e: FormEvent<HTMLFormElement>) => void;
    removeEmailFromContactUsEmails: (itemValue: string) => void;
    onChangeInputEmailForContactUsEmails: (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => void;
    copyDataFromAccountUsingPropertyName: (value: string) => void;

}
export const FlyerEmailSettings: React.FC<Props> = ({
                                                        isFlyerPublished,
                                                        readonly,
                                                        isValidEmailFromInputContactUsEmails,
                                                        inputValueForContactUsEmails,
                                                        contactUsEmails,
                                                        addItemToContactUsEmails,
                                                        removeEmailFromContactUsEmails,
                                                        onChangeInputEmailForContactUsEmails,
                                                        copyDataFromAccountUsingPropertyName
                                                    }) => {
    const copyDataFromAccount = (e: React.MouseEvent<HTMLButtonElement>) => {
        const btnName = e.currentTarget as HTMLButtonElement;
        copyDataFromAccountUsingPropertyName(btnName.name);
    }

    return (
        <Box sx={{flex: `1 1 auto`, overflow: "auto"}}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    height: '18px',
                    margin: "0 0 8px"
                }}
            >
                {
                    !readonly && !isFlyerPublished &&
                    <Button
                        name={"valuesForContactUsEmails"}
                        disableTouchRipple
                        onClick={copyDataFromAccount}
                    >
                        <Typography sx={{fontSize: `12px`, fontWeight: `bold`, color: `#E5870E`}}
                                    textTransform={`capitalize`}>
                            Copy From Account
                        </Typography>
                    </Button>
                }
            </Box>
            <Box>
                {/*rows*/}
                <InputWithShowingResults
                    values={contactUsEmails}
                    addItem={addItemToContactUsEmails}
                    removeItem={removeEmailFromContactUsEmails}
                    inputValue={inputValueForContactUsEmails}
                    fieldName={"email"}
                    labelGridSizeNumber={4}
                    labelCaption={'Contact Us Emails:'}
                    onChangeInput={onChangeInputEmailForContactUsEmails}
                    isValid={isValidEmailFromInputContactUsEmails}
                    labelAlign={"start"}
                    isReadOnly={!!readonly}
                />
            </Box>
        </Box>

    )
}